import React from "react";
import qs from "qs";
import MasterTemplate from "./MasterTemplate";
import Cleave from "cleave.js/react"
import Axios from 'axios'
var bcrypt = require('bcryptjs')


export class MasterCadastroAdmin extends React.Component {
    constructor(props) {
        window.localStorage.setItem("rotaAtual", window.location.href.split('/')[3]);
        super(props);
        this.state = {
            user: JSON.parse(localStorage.getItem("user")),
            admin: undefined,
            queryString: qs.parse(this.props.location.search, { ignoreQueryPrefix: true }),
            confirmarSenha: '',
            senha: ''
        }
        this.getUser();
    }

    async getUser() {
        if (this.state.queryString.id) {
            try {
                var axiosInstance = new Axios.create({
                    baseURL: window.localStorage.getItem("apiUrl")
                })
                const response = await axiosInstance.post("usuarios/user", {
                    id: this.state.queryString.id
                })
                this.setState({ admin: response.data })
            } catch (err) {
                console.log(err)
            }
        }
    }

    concluirAdmin() {

        if (this.state.senha !== this.state.confirmarSenha) {
            alert('Você deve preencher as senhas corretamente nos campos!')
            return;
        }
        if (!this.state.queryString.id) {
            this.cadastrarAdmin();

        }
        else if (this.state.queryString.id && this.state.senha != '' && this.state.senha == this.state.confirmarSenha) {
            this.atualizarAdmin();
        }
        else if (this.state.queryString.id && this.state.senha == '') {
            this.atualizarAdminSemPassword();
        }
    }

    async cadastrarAdmin() {
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem("apiUrl")
            })
            const salt = await bcrypt.genSalt()
            const hash = await bcrypt.hash(this.state.senha, salt)
            const response = await axiosInstance.post("usuarios/cadastrar-admin", { ...this.state.admin, senha: hash, tutorId: this.state.user._id })
            window.document.getElementById("btn-concluir").ariaDisabled = true;
            if(response){
                window.location.href = '/master-gerenciar-admins';
            }
        } catch (err) {
            console.log(err)
            alert(err)
        }
    }
    async atualizarAdmin() {

        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem("apiUrl")
            })
            const salt = await bcrypt.genSalt()
            const hash = await bcrypt.hash(this.state.senha, salt)
            const response = await axiosInstance.post("usuarios/update-one-user", { ...this.state.admin, senha: hash })
            if(response)
                window.location.href = '/master-gerenciar-admins';
        } catch (err) {
            console.log(err)
            alert(err)
        }
    }

    async atualizarAdminSemPassword() {
        delete this.state.admin['senha']
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem("apiUrl")
            })
            const response = await axiosInstance.post("usuarios/update-one-user", { ...this.state.admin })
            window.location.href = '/master-gerenciar-admins';
        } catch (err) {
            console.log(err)
            alert(err)
        }
    }

    handleInputChange(event) {
        const { name, value } = event.target
        if (name == 'confirmarSenha') {
            this.setState({ confirmarSenha: value })

        }
        else if (name == 'senha') {
            this.setState({ senha: value })

        }
        else {
            if (this.state.admin == undefined)
                this.state.admin = { [name]: value }

            this.state.admin[name] = value;
            this.setState({ admin: this.state.admin })
        }
    }

    render() {
        return (
            <MasterTemplate label="Cadastrar Admin">
                <div className="content">
                    <div className="container-fluid">

                        <div className="row">
                            <div className="col-md-12 col-lg-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h4 className="card-title">Cadastro de Admin</h4>
                                    </div>
                                    <div className="card-body">
                                        <input className="form-control" onChange={this.handleInputChange.bind(this)} name="nome" placeholder="Nome" value={this.state.admin?.nome}></input>
                                        <Cleave
                                            onChange={this.handleInputChange.bind(this)} name="cpf" placeholder="CPF" data-length="11"
                                            value={this.state.admin?.cpf}
                                            className={`form-control mt-3`}
                                            options={{
                                                numericOnly: true,
                                                delimiters: ['.', '.', '-'],
                                                blocks: [3, 3, 3, 2]
                                            }}
                                        />
                                        <Cleave onChange={this.handleInputChange.bind(this)} name="telefone"
                                            value={this.state.admin?.telefone}
                                            placeholder="Telefone"
                                            data-length="10"
                                            className="form-control mt-3"
                                            options={{
                                                phone: true,
                                                phoneRegionCode: 'BR'
                                            }}
                                        />
                                        <input className="form-control mt-3" onChange={this.handleInputChange.bind(this)} placeholder="E-mail" name="email" value={this.state.admin?.email}></input>
                                        <select id="status" onChange={this.handleInputChange.bind(this)} name="status"
                                            className="form-control custom-select mt-3"
                                            style={{ height: 'calc(2.25rem + 4px)' }}>
                                            <option value={this.state.admin?.status ? 'Ativo' : 'Bloqueado'}>{this.state.admin?.status ? 'Ativo' : 'Bloqueado'}</option>
                                            <option value="true">Ativo</option>
                                            <option value="false">Bloqueado</option>
                                        </select>
                                        <div className="d-flex mt-3">
                                            <input className="form-control" onChange={this.handleInputChange.bind(this)} name="senha" type="password" placeholder="Senha"></input>
                                            <input className="form-control ml-5" type="password" onChange={this.handleInputChange.bind(this)} name="confirmarSenha" placeholder="Confirmar senha"></input>
                                        </div>
                                        <button id="btn-concluir" className="mt-3 btn-fill btn btn-success" onClick={this.concluirAdmin.bind(this)}>Concluir</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </MasterTemplate>
        );
    }
}

export default MasterCadastroAdmin;
